module.exports = __webpack_public_path__ + "img/car_shina2_15.af613d39.jpg";